var _path, _path2, _mask, _path3, _path4, _ellipse, _g, _ellipse2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4194 6.33284C15.4194 8.83956 13.4718 10.849 11.0968 10.849C8.72181 10.849 6.77424 8.83956 6.77424 6.33284C6.77424 3.82612 8.72181 1.81672 11.0968 1.81672C13.4718 1.81672 15.4194 3.82612 15.4194 6.33284Z",
    fill: "white",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22578 6.33284C9.22578 8.83956 7.27821 10.849 4.90321 10.849C2.5282 10.849 0.580636 8.83956 0.580636 6.33284C0.580636 3.82612 2.5282 1.81672 4.90321 1.81672C7.27821 1.81672 9.22578 3.82612 9.22578 6.33284Z",
    fill: "white",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2802_5078",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00006 9.93945C8.95038 9.05345 9.54845 7.76589 9.54845 6.33283C9.54845 4.89976 8.95038 3.6122 8.00006 2.7262C7.04973 3.6122 6.45166 4.89976 6.45166 6.33283C6.45166 7.76589 7.04973 9.05345 8.00006 9.93945Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00006 9.93945C8.95038 9.05345 9.54845 7.76589 9.54845 6.33283C9.54845 4.89976 8.95038 3.6122 8.00006 2.7262C7.04973 3.6122 6.45166 4.89976 6.45166 6.33283C6.45166 7.76589 7.04973 9.05345 8.00006 9.93945Z",
    fill: "#2E5CF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00006 9.93945L7.56011 10.4113L8.00006 10.8215L8.44 10.4113L8.00006 9.93945ZM8.00006 2.7262L8.44 2.25431L8.00006 1.84414L7.56011 2.25431L8.00006 2.7262ZM8.90329 6.33283C8.90329 7.58404 8.38169 8.7016 7.56011 9.46756L8.44 10.4113C9.51908 9.40531 10.1936 7.94774 10.1936 6.33283L8.90329 6.33283ZM7.56011 3.19809C8.38169 3.96405 8.90329 5.08161 8.90329 6.33283L10.1936 6.33283C10.1936 4.71791 9.51908 3.26034 8.44 2.25431L7.56011 3.19809ZM7.09682 6.33283C7.09682 5.08161 7.61843 3.96405 8.44 3.19809L7.56011 2.25431C6.48103 3.26034 5.8065 4.71791 5.8065 6.33283H7.09682ZM8.44 9.46756C7.61843 8.7016 7.09682 7.58404 7.09682 6.33283H5.8065C5.8065 7.94774 6.48103 9.40531 7.56011 10.4113L8.44 9.46756Z",
    fill: "#2E5CF6",
    mask: "url(#path-3-inside-1_2802_5078)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2802_5078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 10,
    height: 11
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.90321,
    cy: 6.33284,
    rx: 4.64515,
    ry: 4.8387,
    fill: "#DDDDDD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2802_5078)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.1169,
    y2: -0.32258,
    transform: "matrix(-0.692532 0.721388 -0.948029 -0.318186 7.44043 8.5293)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.1169,
    y2: -0.32258,
    transform: "matrix(-0.692532 0.721387 -0.948029 -0.318186 7.44043 5.88477)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.1169,
    y2: -0.32258,
    transform: "matrix(-0.692532 0.721387 -0.948029 -0.318186 7.44043 3.24219)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.7345,
    y2: -0.32258,
    transform: "matrix(-0.692532 0.721387 -0.948029 -0.318186 7.90918 0.154297)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.7345,
    y2: -0.32258,
    transform: "matrix(-0.692532 0.721387 -0.948029 -0.318186 7.90918 -2.39648)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2802_5078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 10,
    height: 11
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0968,
    cy: 6.33284,
    rx: 4.8387,
    ry: 4.64515,
    transform: "rotate(90 11.0968 6.33284)",
    fill: "#DDDDDD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2802_5078)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.1169,
    y2: -0.32258,
    transform: "matrix(-0.692532 -0.721388 0.295502 -0.955342 12.0857 12.4414)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.1169,
    y2: -0.32258,
    transform: "matrix(-0.692532 -0.721387 0.295502 -0.955342 13.5918 11.2227)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.1169,
    y2: -0.32258,
    transform: "matrix(-0.692532 -0.721387 0.295502 -0.955342 15.0967 10.1465)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.7345,
    y2: -0.32258,
    transform: "matrix(-0.692532 -0.721387 0.295502 -0.955342 17.0293 9.55859)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.32258,
    x2: 11.7345,
    y2: -0.32258,
    transform: "matrix(-0.692532 -0.721387 0.295502 -0.955342 17.4143 7.41016)",
    stroke: "#2E5CF6",
    strokeWidth: 0.64516
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerged);
export default __webpack_public_path__ + "static/media/merged.8178d827.svg";
export { ForwardRef as ReactComponent };